export default {"src":"/_next/static/media/download.01ad33ad.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};